import defaultNavbar from "./default";
import logisticNavbar from "./logisticNavbar";
import reliableNavabr from "./ReliableNavbar";

export default [defaultNavbar, logisticNavbar, reliableNavabr];
